import { reactive } from 'vue'

export class GoLiveStateClass {
  state = reactive({
    microphoneId: '',
    cameraId: '',
    speakerId: '',
  })
  setMicrophoneId(microphoneId: string): void {
    this.state.microphoneId = microphoneId
  }
  setCameraId(cameraId: string): void {
    this.state.cameraId = cameraId
  }
  setSpeakerId(speakerId: string): void {
    this.state.speakerId = speakerId
  }
}

export const GoLiveState = new GoLiveStateClass()
